import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { IFlashProfilesByLotResponse, IFlashLocationProfile, IFlashPool } from 'src/app/shared/code/interfaces/parcs-interfaces';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'app-flash-add-new-parker',
  standalone: true,
  imports: [
        MatFormField,
        MatOptionModule,
        MatSelectModule,
        FormsModule,
        NgFor,
        MatCheckboxModule,
        MatTooltipModule,
        MatIconModule,
  ],
  templateUrl: './flash-add-new-parker.component.html',
  styleUrl: './flash-add-new-parker.component.scss'
})
export class FlashAddNewParkerComponent implements OnInit {
  createFlashAccount: boolean = true;
  profileId: string = '';
  poolName: string = '';
  profileData:IFlashProfilesByLotResponse = {} as IFlashProfilesByLotResponse;
  profileList: IFlashLocationProfile[] = [];
  // Flash has no "list pools" endpoint, so the names come from the lot's spACE-AR pool admin list.
  poolList: IFlashPool[] = [];

  // Output names and semantics intentionally mirror AmanoOneNewParkerComponent so the parent treats all PARCS children alike.
  @Output() broadcastParcsStatus = new EventEmitter<boolean>();
  @Output() broadcastCreateFlashAccount = new EventEmitter<boolean>();
  @Output() broadcastProfileId = new EventEmitter<string>();
  @Output() broadcastProfileName = new EventEmitter<string>();
  @Output() broadcastPoolName = new EventEmitter<string>();
  @Output() broadcastDataIsInvalid = new EventEmitter<boolean>();

  //Services
  _parcsDataService = inject(ParcsDataService);
  _appGeneralState = inject(AppGeneralStateService);

  constructor() {
    this.getProfileList();
    this.getPoolList();
  }

  // Outputs are not subscribed until after the constructor, so the initial state is published here.
  ngOnInit(): void {
    this.broadcastCurrentState();
  }

  onProfileGroupChange(event: any) {
      this.profileId = event;
      this.broadcastCurrentState();
  }

  onPoolGroupChange(event: any) {
      this.poolName = event;
      this.broadcastCurrentState();
  }

  onSaveFlashProfileChange(){
    this.broadcastCurrentState();
  }

  getProfileList():void{
    this._parcsDataService.flash_GetProfilesByLotNumber(this._appGeneralState.currentLotNumber).subscribe({
      next: (response) => {
        this.profileData = response;
        this.profileList = response.locationProfiles;
      },
      error: (error) => {
        console.error('Error fetching Flash profiles:', error);
      }
    });
  }

  getPoolList():void{
    this._parcsDataService.flash_GetPoolsByLotNumber(this._appGeneralState.currentLotNumber).subscribe({
      next: (response) => {
        this.poolList = response;
      },
      error: (error) => {
        this.poolList = [];
      }
    });
  }

  /// broadcastParcsStatus emits true when the Flash account is being skipped, matching the Amano One child's contract.
  private broadcastCurrentState(): void {
    this.broadcastCreateFlashAccount.emit(this.createFlashAccount);
    this.broadcastProfileId.emit(this.profileId);
    // MonthlyAccount5 takes the profile name, not the uniqueID the dropdown is keyed on.
    this.broadcastProfileName.emit(this.profileList.find((profile) => profile.uniqueID === this.profileId)?.name ?? '');
    this.broadcastPoolName.emit(this.poolName);
    this.broadcastParcsStatus.emit(!this.createFlashAccount);
    this.broadcastDataIsInvalid.emit(this.createFlashAccount && this.profileId === '');
  }
}
